/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * ToogleVisibility.js
 * toggle .back-to-top--active to .back-to-top when page is scrolled
 */

import { useEffect, useState } from 'react';

/**
 * Toggle .back-to-top--active class to .back-to-top when page is scrolled
 */
const ToogleVisibility = () => {
  const [visibility, setVisibility] = useState(null);

  // Similar to componentDidMount and componentDidUpdate.
  // Runs both after the first render
  useEffect(() => {
    // Runs after every update
    const updateVisibility = () => {
      if (window.scrollY > 300) {
        setVisibility('back-to-top--active');
      } else {
        setVisibility(null);
      }
    };

    window.addEventListener('scroll', updateVisibility);

    // Cleanup
    return () => window.removeEventListener('scroll', updateVisibility);
  }, []);
  // Run the effect and clean it up only once (on mount and unmount).
  // If you pass an empty array ([]), the props and state inside the effect will always have their initial values.

  return visibility;
};

export default ToogleVisibility;